import { message } from 'antd';
import useCheckRouterValid from 'hook/useCheckRouterValid';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { messageFeedback, userInformation } from 'recoil/atom/authentication';
import { appRouter, authenticationRouter } from 'router';
import { getTrackingCode } from 'api/trackingCode/trackingCode.api';
import useCustomQuery from 'hook/useQuery/useCustomQuery';

const App = () => {
  const { useQueryAPI } = useCustomQuery();
  const { checkRouterValid } = useCheckRouterValid();
  const { role } = useRecoilValue(userInformation);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessageFeedback, setShowMessageFeedback] =
    useRecoilState(messageFeedback);

  const { data: trackingCodeList = [] } = useQueryAPI({
    api: getTrackingCode,
    key: 'trackingCodeList',
    params: {
      pageNumber: 1,
      pageSize: 10,
      isAll: true,
    },
  });

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  useEffect(() => {
    window.addEventListener('keypress', handleKeyPress);

    if (showMessageFeedback.display) {
      messageApi
        .open({
          type: showMessageFeedback.type,
          content: showMessageFeedback.content,
        })
        .then(() =>
          setShowMessageFeedback({
            display: false,
            content: '',
            type: 'error',
          }),
        );
    }

    return window.removeEventListener('keypress', handleKeyPress);
  }, [messageApi, showMessageFeedback, setShowMessageFeedback]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('./maintenancetimeconfig.json');
        const jsonData = await response.json();
        if (jsonData.isMaintenance === false) {
          localStorage.removeItem('isMaintenance');
        } else {
          localStorage.setItem('isMaintenance', jsonData.isMaintenance);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (trackingCodeList?.data?.list?.length) {
      const insertedNodes = [];

      trackingCodeList.data.list.forEach((trackingCode) => {
        if (trackingCode.header) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = trackingCode.header;

          const children = Array.from(tempDiv.childNodes);
          children.forEach((child) => {
            if (child.tagName === 'SCRIPT') {
              const script = document.createElement('script');

              if (child.src) {
                script.src = child.src;
                script.async = true;
              } else {
                script.textContent = child.textContent;
              }

              document.head.appendChild(script);
              insertedNodes.push(script);
            } else {
              document.head.appendChild(child);
              insertedNodes.push(child);
            }
          });
        }

        if (trackingCode.body) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = trackingCode.body;

          const children = Array.from(tempDiv.childNodes);
          children.forEach((child) => {
            document.body.appendChild(child);
            insertedNodes.push(child);
          });
        }
      });

      return () => {
        insertedNodes.forEach((node) => node.parentNode?.removeChild(node));
      };
    }
  }, [trackingCodeList?.data]);

  return (
    <>
      {contextHolder}
      <RouterProvider
        router={checkRouterValid ? appRouter[role] : authenticationRouter}
      />
    </>
  );
};

export default App;
